export default {
    PAGE: {
        BETRIEB: {
            DOWNLOADS: '/downloads',
        },
    },
    API: {
        BETRIEBSDOWNLOADS: '/betrieb/:betrieb_nr/download',
    },
};
